/** ฝ่ามือมังกร (lane C4 skeleton): gold + leaf, motif wings. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const DRAGONPALM_FX: ReturnType<typeof makeHandArt> = makeHandArt('dragon-palm', { a: 'gold', b: 'leaf', motif: 'wings' }, [
  ['dp-regret', 'palm', 2],
  ['dp-tail', 'grab'],
  ['dp-field', 'ring', 3.5],
  ['dp-leap', 'palm', 5],
  ['dp-soar', 'ring', 5],
  ['dp-scales', 'buff'],
  ['dp-hidden', 'heal'],
  ['dp-eighteen', 'power', 4],
]);
